<template>
  <div class="content-progres">
    <h4 class="progres-name content-mb-14">
      Документы для подписания договора
    </h4>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-6">
        <div class="row myrow">
          <p class="progres-label">
            Загружено документов
            {{ documentConf.FILE_LOAD_INFO.FACT_LOAD }}/{{
              documentConf.FILE_LOAD_INFO.NEED_LOAD
            }}
          </p>
          <div class="col-lg-6 col-md-8 mycol">
            <div class="progress progress-striped">
              <div
                class="progress-bar progress-bar-success"
                role="progressbar"
                :aria-valuenow="documentConf.FILE_LOAD_INFO.FACT_LOAD"
                aria-valuemin="0"
                :aria-valuemax="documentConf.FILE_LOAD_INFO.NEED_LOAD"
                :style="{
                  width:
                    (100 / documentConf.FILE_LOAD_INFO.NEED_LOAD) *
                      documentConf.FILE_LOAD_INFO.FACT_LOAD +
                    '%'
                }"
              >
                <span class="sr-only">90% Завершено (Успешно)</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-8"></div>
        </div>
        <div v-if="documentConf.IS_RFRP_PROGRAM" class="row myrow">
          <p class="progres-label">
            Акцептовано РФРП
            {{ documentConf.FILE_ACCEPT_INFO_RFRP.FACT_ACCEPT_YES }}/{{
              documentConf.FILE_ACCEPT_INFO_RFRP.NEED_ACCEPT
            }}
          </p>
          <div class="col-lg-6 col-md-8 mycol">
            <div class="progress progress-striped">
              <div
                class="progress-bar progress-bar-info"
                role="progressbar"
                :aria-valuenow="
                  documentConf.FILE_ACCEPT_INFO_RFRP.FACT_ACCEPT_YES
                "
                aria-valuemin="0"
                :aria-valuemax="documentConf.FILE_ACCEPT_INFO_RFRP.NEED_ACCEPT"
                :style="{
                  width:
                    (100 / documentConf.FILE_ACCEPT_INFO_RFRP.NEED_ACCEPT) *
                      documentConf.FILE_ACCEPT_INFO_RFRP.FACT_ACCEPT_YES +
                    '%'
                }"
              >
                <span class="sr-only">30% Завершено (Информация)</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-8 mycol"></div>
        </div>
        <div class="row myrow">
          <p class="progres-label">
            Акцептовано документов
            {{
              documentConf.FILE_ACCEPT_INFO_ELECTRONIC_VIEW.FACT_ACCEPT_YES
            }}/{{ documentConf.FILE_ACCEPT_INFO_ELECTRONIC_VIEW.NEED_ACCEPT }}
          </p>
          <div class="col-lg-6 col-md-8 mycol">
            <div class="progress progress-striped">
              <div
                class="progress-bar progress-bar-success"
                role="progressbar"
                :aria-valuenow="
                  documentConf.FILE_ACCEPT_INFO_ELECTRONIC_VIEW.FACT_ACCEPT_YES
                "
                aria-valuemin="0"
                :aria-valuemax="
                  documentConf.FILE_ACCEPT_INFO_ELECTRONIC_VIEW.NEED_ACCEPT
                "
                :style="{
                  width:
                    (100 /
                      documentConf.FILE_ACCEPT_INFO_ELECTRONIC_VIEW
                        .NEED_ACCEPT) *
                      documentConf.FILE_ACCEPT_INFO_ELECTRONIC_VIEW
                        .FACT_ACCEPT_YES +
                    '%'
                }"
              >
                <span class="sr-only">90% Завершено (Успешно)</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-8 mycol"></div>
        </div>
        <div class="row myrow">
          <p class="progres-label">
            Предоставлено оригиналов документов
            {{ documentConf.FILE_ACCEPT_INFO_PAPER_VIEW.FACT_ACCEPT_YES }}/{{
              documentConf.FILE_ACCEPT_INFO_PAPER_VIEW.NEED_ACCEPT
            }}
          </p>
          <div class="col-lg-6 col-md-8 mycol">
            <div class="progress progress-striped">
              <div
                class="progress-bar progress-bar-success"
                role="progressbar"
                :aria-valuenow="
                  documentConf.FILE_ACCEPT_INFO_PAPER_VIEW.FACT_ACCEPT_YES
                "
                aria-valuemin="0"
                :aria-valuemax="
                  documentConf.FILE_ACCEPT_INFO_PAPER_VIEW.NEED_ACCEPT
                "
                :style="{
                  width:
                    (100 /
                      documentConf.FILE_ACCEPT_INFO_PAPER_VIEW.NEED_ACCEPT) *
                      documentConf.FILE_ACCEPT_INFO_PAPER_VIEW.FACT_ACCEPT_YES +
                    '%'
                }"
              >
                <span class="sr-only">90% Завершено (Успешно)</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-8 mycol"></div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-6">
        <p v-for="vid in vid_doc">
          <template v-if="vid.CODE != 'scan'">
            {{ vid.NAME }}
          </template>
        </p>

        <div
          v-if="
            $parent.currentUser.TYPE_USER === 'manager' &&
              $parent.project.UF_DATE_FIRST_SAVE_D_DZ_FORMAT
          "
        >
          <br />
          <b>Дата первого сохранения чек-листа (отображения заявителю):</b>
          {{ $parent.project.UF_DATE_FIRST_SAVE_D_DZ_FORMAT }}
        </div>
      </div>
    </div>

    <div class="row" v-if="documentConf.LOAN_TERM_TEXT.IS_VIEW_TEXT_SROK_ZAIM">
      <VDropdown
        tag="span"
        trigger="click"
        placement="auto"
        popperClass="custom-popper"
        :distance="20"
      >
        <a class="icon-help-blue">
          &nbsp;
        </a>
        <template #popper>
          <div class="custom-popper-content">
            {{ documentConf.LOAN_TERM_TEXT.TEXT_TITLE }}
          </div>
        </template>
      </VDropdown>
      <p class="text-loan-zaim-dz">
        <b>{{ documentConf.LOAN_TERM_TEXT.TEXT_LABEL }}</b>
      </p>
    </div>
  </div>
</template>

<script>
import { Dropdown as VDropdown } from "floating-vue";

export default {
  props: ["documentConf", "vid_doc"],
  name: "ProgressDZ",
  components: {
    VDropdown
  },
  data() {
    return {
      //   documentConf: {
      //     FILE_ACCEPT_INFO_RFRP: {
      //       NEED_ACCEPT: 1,
      //       FACT_ACCEPT: 0,
      //       FACT_ACCEPT_YES: 0,
      //       FACT_ACCEPT_NO: 0
      //     },
      //     LIST_TYPE: [],
      //     FILE_DOCUMENTS_PATH: {},
      //     FILE_DOCUMENTS_SETTING: {},
      //     FILE_LIST_TYPE_ID: [],
      //     FILE_LOAD_INFO: { NEED_LOAD: 1, FACT_LOAD: 0 }
      //   }
    };
  }
};
</script>

<style></style>
